module.exports = __webpack_public_path__ + "img/10.2f83f24c.png";